export const showOffseasonMenuLabel = (sport: string) => {
    if (sport === 'Cricket') return true
    if (sport === 'WAFL') return true
}
